/**
 * Raw heat conversion functions.
 *
 * Section 3.4.2.17.
 */
export const convertRawHeat = {
  /**
   * To weld machine: 7.8 kJ/s => 78
   * @param rawHeat Raw heat kJ/s.
   * @returns Weld machine format.
   */
  toWeldMachine: (rawHeat: number) => Math.round(rawHeat * 10),

  /**
   * From weld machine: 78 => 7.8 kJ/s
   * @param received Weld machine format.
   * @returns Raw heat kJ/s.
   */
  fromWeldMachine: (received: number) => received / 10,
};
